import { MY_LIFESTYLE } from '../constants';
import { LIFESTYLE } from '../constants/progressCategories';

import * as consultationComponents from '../constants/consultationComponents';

const myLifestyleZipcode = {
  name: 'zipcode',
  category: MY_LIFESTYLE,
  progressCategory: LIFESTYLE,
  route: `/consultation/${MY_LIFESTYLE}/zipcode`,
  title: 'Where will you be spending most of your time in the next 2 months?',
  subtitle: (
    <>
      Your location tells us what environmental stressors your hair needs to be shielded from on a
      daily basis. We’ll also update your formulas throughout the year to reflect the actual weather
      conditions in your area.
      <br />
    </>
  ),
  shouldBeIncluded: () => true,
  getInitialValue: ({ profile_zipcode, profile_country }) => ({
    profile_zipcode,
    profile_country,
  }),
  getAnswers: ({ profile_zipcode, profile_country }) => ({
    profile_zipcode,
    profile_country,
  }),
  Component: consultationComponents.ZipCodeContainer,
  skipSave: true, // The component will manage its own save strategy, we will just redirect
};

export default myLifestyleZipcode;
